import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter, useLocation, useHistory } from 'react-router-dom'
import { withTheme } from 'styled-components'
import { apiPOSTReq } from '../../../Utils/api'
import { ErrorAlert } from '../../Reusable/Alert'
import environment from '../../../environment'
import { Modal, Tabs, Skeleton } from 'antd'
import { Flex, FlexColumn, CardContainer } from '../../Reusable/Container'
import { Text, Tag } from '../../Reusable/Text'
import PageHeader from '../../Reusable/PageHeader'
import FullScreenModal from '../../Reusable/FullScreenModal'
import { fetchBBHistory, fetchDACAHistory, normalizeAndSortHistory } from '../../../Utils/bankingDataManager'
import { getBPAccountsWithAccess, toCurrency, formatAvailabilitySchedule } from '../../../Utils/util'
import PendingTable from '../Reusable/PendingTable'
import SearchAndFilter from '../../Reusable/SearchAndFilter'

// Images
import AccountNameModal from '../Reusable/AccountNameModal'
import ModalClose from '../../../Images/modal-close.png'


const { TabPane } = Tabs

const ClearingTransactions = (props) => {
    const [account, setAccount] = useState(null)
    const [accountIndex, setAccountIndex] = useState(0)
    const [type, setType] = useState()
    const [paymentStatus, setPaymentStatus] = useState([])
    const [postedTransfers, setPostedTransfers] = useState([])
    const [showAccountNameModal, setShowAccountNameModal] = useState(false)
    const [loadingHolds, setLoadingHolds] = useState(true)
    const [loadingPending, setLoadingPending] = useState(true)
    const [loadingBalances, setLoadingBalances] = useState(true)
    const [fullScreenModalContent, setFullScreenModalContent] = useState(null)
    const [holdInfoList, setHoldInfoList] = useState([])
    const [dacaBusinessId, setDacaBusinessId] = useState(null)
    const [pendingTransfers, setPendingTransfers] = useState([])
    const [accountBalanceInfo, setAccountBalanceInfo] = useState(null)


    const location = useLocation()
    const history = useHistory()
    const daca = location?.state?.daca

    const urlStr = location.search.replace('?', '')
    const mask = (new URLSearchParams(urlStr).get('mask') || '')

    const tab = location.state?.tab ? location.state?.tab : 'clearing'

    useEffect(() => {
        var accounts = getBPAccountsWithAccess("Transactions", { getActiveAccounts: true })
        accounts = accounts || []

        console.log("ClearingTransactions accounts", accounts)
        console.log("ClearingTransactions account", accounts?.find(acc => acc.accountNumber === location.state.accountNumber))
        console.log("ClearingTransactions account dacaBusinessId", location.state.dacaBusinessId)

        setAccount(accounts?.find(acc => acc.accountNumber === location.state.accountNumber))

        if (location.state.dacaBusinessId) {
            setDacaBusinessId(location.state.dacaBusinessId)
            getHolds({ dacaBusinessId: location.state.dacaBusinessId })
        } else {
            getHolds()
            // getHolds({ sorter: { field: "expiresAt", order: "ascend" } })
        }

        getMemoPosts()
        getAccountBalanceInfo()
    }, [])

    const getHolds = (options) => {
        setHoldInfoList([]);

        const { pagination = {}, sorter = {}, dacaBusinessId, searchStr, fromAmt, toAmt, fromDate, toDate, railList, expiresAt } = options || {}

        if (railList && railList.includes("ACH")) railList.push("Ach")
        if (railList && railList.includes("Check")) railList.push("Checks")
        if (railList && railList.includes("Wire")) railList.push("Wires")
        if (railList && railList.includes("Account")) railList.push("Internal")

        const body = {
            accountNumber: location?.state?.accountNumber,
            sortFieldName: sorter.field === "expiresAt" ? "ExpiresAt" : sorter.field === "date" ? "createdAt" : sorter.field === "type" ? "rail" : sorter.field || "ExpiresAt",
            sortDirection: sorter.order === 'descend' ? "DESC" : "ASC",
            // page: pagination.current || 1,
            // pageSize: pagination.pageSize || 10,
            dacaBusinessId: location.state.dacaBusinessId || dacaBusinessId,
            fromAmt,
            toAmt,
            fromDate,
            toDate,
            filterValue: expiresAt ? "ExpiresAt" : "CreatedAt",
        };

        if (railList) body.railList = railList

        if (searchStr) {
            body.searchStr = searchStr;
            body.viewBy = 'SEARCH';
        }

        console.log("/bb/getHolds body options", options);
        console.log("/bb/getHolds body", body);

        setLoadingHolds(true);

        apiPOSTReq(`${environment.bbBaseUrl}/bb/getHolds`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp;
                if (data.result) {

                    console.log("/bb/getHolds resp", resp);

                    const updatedArray = data?.holdInfoList.map(obj => ({
                        ...obj,
                        objectId: obj.objectId ?? (obj.railId?.replace("payment/", "") || null),
                        type: obj.rail === "Wires" ? "Wire" : obj.rail === "Internal" ? "Account" : obj.rail,
                        hideExpand: obj.rail === "Internal",
                        status: null,
                    }));

                    setHoldInfoList(updatedArray || []);
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later");
                }
            } catch (error) {
                console.log("ERRR getHolds", error, err, resp);
            } finally {
                setLoadingHolds(false);
            }
        });
    };

    const getMemoPosts = (options) => {
        setHoldInfoList([]);

        const { pagination = {}, sorter = {}, dacaBusinessId, searchStr, fromAmt, toAmt, fromDate, toDate, railList, expiresAt } = options || {}

        if (railList && railList.includes("ACH")) railList.push("Ach")
        if (railList && railList.includes("Check")) railList.push("Checks")
        if (railList && railList.includes("Wire")) railList.push("Wires")
        if (railList && railList.includes("Account")) railList.push("Internal")

        const body = {
            accountNumber: location?.state?.accountNumber,
            sortFieldName: sorter.field === "expiresAt" ? "ExpiresAt" : sorter.field === "date" ? "createdAt" : sorter.field === "type" ? "rail" : sorter.field || "createdAt",
            sortDirection: sorter.order === 'descend' ? "DESC" : "ASC",
            // // page: pagination.current || 1,
            // // pageSize: pagination.pageSize || 10,
            // dacaBusinessId: location.state.dacaBusinessId || dacaBusinessId,
            fromAmt,
            toAmt,
            fromDate,
            toDate,
            // filterValue: expiresAt ? "ExpiresAt" : "CreatedAt",
            // rail : "Checks",,
            transactionTypeList: ["Debit", "Credit"],
            filterValue: "CreatedAt",
        };

        if (railList) body.railList = railList

        if (searchStr) {
            body.searchStr = searchStr;
            body.viewBy = 'SEARCH';
        }

        console.log("/bb/getMemoPosts body options", options);
        console.log("/bb/getMemoPosts body", body);

        setLoadingPending(true);

        apiPOSTReq(`${environment.bbBaseUrl}/bb/getMemoPosts`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp;
                if (data.result) {

                    console.log("/bb/getMemoPosts resp", resp);

                    const updatedArray = data?.memoPostList.map(obj => ({
                        ...obj,
                        objectId: obj.objectId ?? (obj.railId?.replace("payment/", "") || null),
                        rail: obj.rail?.toLowerCase() === "rtp" ? "Instant" : obj.rail === "Internal" ? "Card" : obj.rail,
                        hideExpand: obj.rail === "Internal",
                    }));

                    const pendingTransfers = { cardMemoList: updatedArray, useCardMemoRail: true }
                    var normalizedHistory = normalizeAndSortHistory(pendingTransfers, false);

                    setPendingTransfers(normalizedHistory.normalizedData)

                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later");
                }
            } catch (error) {
                console.log("ERRR getMemoPosts", error, err, resp);
            } finally {
                setLoadingPending(false);
            }
        });
    };

    const getAccountBalanceInfo = (options) => {
        const body = {
            AccountNumber: location?.state?.accountNumber,
        };

        console.log("/bb/getAccountBalanceInfo' body", body);

        setLoadingBalances(true);

        apiPOSTReq(`${environment.bbBaseUrl}/bb/getAccountBalanceInfo`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp;

                console.log("/bb/getAccountBalanceInfo' resp", resp);
                if (data.result) {

                    console.log("/bb/getAccountBalanceInfo resp", resp);

                    setAccountBalanceInfo(resp?.accountBalanceInfo)

                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later");
                }
            } catch (error) {
                console.log("ERRR getAccountBalanceInfo", error, err, resp);
            } finally {
                setLoadingBalances(false);
            }
        });
    };

    return (
        <FlexColumn className='main-padding' start>
            {account && <PageHeader
                titleText={'Pending balance updates'}
                back
                onBack={() => {
                    daca ? props.history.replace({
                        pathname: '/daca/transactions',
                        state: { accountId: account?.accountId }
                    }) :
                        props.history.replace({
                            pathname: '/banking/accounts',
                            state: { accountNumber: account?.accountNumber }
                        })
                }}
            />}

            <CardContainer width="400px" margin="0 0 16px">
                <Skeleton loading={loadingBalances} active title={false} paragraph={{ rows: 4 }}>
                    <FlexColumn left start gap="8px" style={{ width: 342 }}>
                        <Flex start centerH gap="16px" style={{ marginBottom: '12px' }}>
                            <Text weight={600} size='16px'>Summary</Text>
                            <Tag>{account?.nickName || `Business ${account?.accountSubType}`} • {account?.mask}</Tag>
                        </Flex>
                        <Flex fullWidth between>
                            <Text color={props.theme.colors.defaultLightText}>Available Balance</Text>
                            <Text weight="600">${toCurrency(accountBalanceInfo?.availableBalance)}</Text>
                        </Flex>
                        <Flex fullWidth between>
                            <Text color={props.theme.colors.defaultLightText}>In Clearing {accountBalanceInfo?.holdCount ? `(${accountBalanceInfo?.holdCount})` : ""}</Text>
                            <Text color={props.theme.colors.primary9} weight="600">+${toCurrency(accountBalanceInfo?.holdAmount)}</Text>
                        </Flex>
                        <Flex fullWidth between>
                            <Text color={props.theme.colors.defaultLightText}>In Processing {accountBalanceInfo?.memoPostCount ? `(${accountBalanceInfo?.memoPostCount})` : ""}</Text>
                            <Text color={accountBalanceInfo?.memoPostAmount <= 0 ? props.theme.colors.defaultLightText : props.theme.colors.primary9} weight="600">{accountBalanceInfo?.memoPostAmount <= 0 ? '' : '+'}${toCurrency(accountBalanceInfo?.memoPostAmount)}</Text>
                        </Flex>
                        <Flex fullWidth between>
                            <Text color={props.theme.colors.defaultLightText}>Current Balance</Text>
                            <Text weight="600">${toCurrency(accountBalanceInfo?.currentBalance)}</Text>
                        </Flex>
                    </FlexColumn>
                </Skeleton>
            </CardContainer>

            <FlexColumn between style={{ width: '100%', paddingBottom: 24 }}>
                <Tabs size="large" activeKey={tab} onChange={(key) => {
                    history.replace({ pathname: '/banking/accounts/clearing-transactions', state: { tab: key, accountNumber: location?.state?.accountNumber } })
                    if (key === 'clearing') {
                        getHolds();
                    } else {
                        getMemoPosts();
                    }
                }} defaultActiveKey={'clearing'} style={{ margin: '0 24px 0px 0px', minHeight: 700 }}>

                    <TabPane tab="In Clearing" key="clearing">
                        <PendingTable
                            key="in-clearing"
                            marginTop="12px"
                            // more
                            title={`In Clearing`}
                            subtitle={<Text color={props.theme.colors.defaultLightText}>
                                View all pending holds on this account. Funds will be available on their availability date. {accountBalanceInfo && <Text color={props.theme.colors.defaultLightText} weight="600">{accountBalanceInfo?.holdCount} hold{accountBalanceInfo?.holdCount !== 1 ? 's' : ''} totaling ${toCurrency(accountBalanceInfo?.holdAmount)}</Text>}
                            </Text>}
                            collapsible={false}
                            loadingPending={loadingHolds}
                            pendingTransfers={holdInfoList}
                            hideStatus
                            hideDescription
                            showRefId
                            showExpiresAt
                            // setFullScreenModalContent={setFullScreenModalContent}
                            reFetchTransactions={() => { }}
                            amountTitle="Hold Amount"
                            refId
                            custRowKey="holdId"
                            dateLabel="Created Date"
                            sort={true}
                            daca={dacaBusinessId}
                            onChange={(pagination, filters, sorter) => {
                                console.log("Table changed", pagination, filters, sorter);
                                getHolds({ pagination, sorter });
                            }}
                            ctaContent={<SearchAndFilter
                                key='clearingFilter'
                                daca={daca}
                                account={account}
                                accountIndex={accountIndex}
                                more={false}
                                download={false}
                                onChange={(options) => getHolds(options)}
                                placeholder={"Search by Reference ID"}
                                // searchWidth={searchWidth}
                                amountName={"Hold Amount"}
                                noCard={true}
                                pageSize={50}
                                accountRail
                                dateName="Created Date"
                                availabilityDate
                            />}
                        />
                    </TabPane>

                    <TabPane tab="In Processing" key="processing">
                        <PendingTable
                            key="in-processing"
                            marginTop="12px"
                            // more
                            title={`In Processing`}
                            subtitle={<Text color={props.theme.colors.defaultLightText}>
                                View transactions that are processing and haven’t yet been updated on your current balance. {accountBalanceInfo && <Text color={props.theme.colors.defaultLightText} weight="600">{accountBalanceInfo?.memoPostCount} hold{accountBalanceInfo?.memoPostCount !== 1 ? 's' : ''} totaling ${toCurrency(accountBalanceInfo?.memoPostAmount)}</Text>}
                            </Text>}
                            collapsible={false}
                            loadingPending={loadingPending}
                            pendingTransfers={pendingTransfers}
                            hideStatus
                            reFetchTransactions={() => { }}
                            refId
                            hideSortType
                            custRowKey="memoPostId"
                            dateLabel="Created Date"
                            sort={true}
                            daca={dacaBusinessId}
                            onChange={(pagination, filters, sorter) => {
                                console.log("Table changed", pagination, filters, sorter);
                                getMemoPosts({ pagination, sorter });
                            }}
                            ctaContent={<SearchAndFilter
                                key='processingFilter'
                                daca={daca}
                                account={account}
                                accountIndex={accountIndex}
                                more={false}
                                download={false}
                                onChange={(options) => getMemoPosts(options)}
                                placeholder={"Search by Description"}
                                amountTitle="Amount"
                                // searchWidth={searchWidth}
                                noCard={true}
                                pageSize={50}
                                accountRail
                                dateName="Created Date"
                            />}
                        />
                    </TabPane>
                </Tabs>
            </FlexColumn>

            <Modal
                wrapClassName='account-name-modal'
                visible={showAccountNameModal}
                footer={null}
                closable={false}
                maskClosable={true}
                width={776}
                destroyOnClose={true}
                onCancel={() => setShowAccountNameModal(false)}
                closeIcon={<img width='24px' height='24px' src={ModalClose} />}
            >
                <AccountNameModal onCancel={() => setShowAccountNameModal(false)} />
            </Modal>

            {
                fullScreenModalContent &&
                <FullScreenModal
                    onClick={() => { }}
                    content={fullScreenModalContent}
                    onClose={() => setFullScreenModalContent(null)}
                />
            }
        </FlexColumn>
    )
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer,
        bankingStore: state.bankingAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(ClearingTransactions)))